import { useState } from 'react';
import Button from '@/components/ui/Button';
import Input from '@/components/ui/Input';

export default function ConversationAnalyzerForm({ onAnalyze, isLoading }) {
  const [conversationType, setConversationType] = useState('call_transcript');
  const [originalContent, setOriginalContent] = useState('');
  const [industry, setIndustry] = useState('saas');
  const [clientText, setClientText] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (!originalContent.trim()) {
      setError('Please enter a transcript or conversation');
      return;
    }

    if (originalContent.trim().length < 50) {
      setError('Transcript must be at least 50 characters');
      return;
    }

    onAnalyze({
      conversationType,
      originalContent: originalContent.trim(),
      industry,
      clientText: clientText.trim() || null
    });
  };

  return (
    <div className="w-full max-w-2xl mx-auto">
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Conversation Type */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Conversation Type
          </label>
          <select
            value={conversationType}
            onChange={(e) => setConversationType(e.target.value)}
            disabled={isLoading}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100"
          >
            <option value="call_transcript">Call Transcript</option>
            <option value="email_thread">Email Thread</option>
          </select>
        </div>

        {/* Industry */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Industry
          </label>
          <select
            value={industry}
            onChange={(e) => setIndustry(e.target.value)}
            disabled={isLoading}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100"
          >
            <option value="saas">SaaS</option>
            <option value="real-estate">Real Estate</option>
            <option value="insurance">Insurance</option>
            <option value="financial-services">Financial Services</option>
            <option value="automotive">Automotive</option>
            <option value="other">Other</option>
          </select>
        </div>

        {/* Transcript Input */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {conversationType === 'call_transcript' ? 'Call Transcript' : 'Email Thread'}
          </label>
          <textarea
            value={originalContent}
            onChange={(e) => setOriginalContent(e.target.value)}
            placeholder={
              conversationType === 'call_transcript'
                ? 'Paste the call transcript here (e.g., "Prospect: Hi there... You: Great to meet you..."))'
                : 'Paste the email thread here (include all messages)'
            }
            disabled={isLoading}
            className="w-full h-64 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100"
          />
          <p className="text-xs text-gray-500 mt-1">
            {originalContent.length} characters
          </p>
        </div>

        {/* Client Text Message (optional) */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Client Text (optional)
          </label>
          <textarea
            value={clientText}
            onChange={(e) => setClientText(e.target.value)}
            placeholder="Paste the client's text message here to get suggested replies"
            disabled={isLoading}
            className="w-full h-32 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100"
          />
          <p className="text-xs text-gray-500 mt-1">
            Optional: We'll suggest replies tailored to the message.
          </p>
        </div>

        {/* Error Message */}
        {error && (
          <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-sm text-red-700">{error}</p>
          </div>
        )}

        {/* Submit Button */}
        <Button
          type="submit"
          disabled={isLoading || !originalContent.trim()}
          className="w-full"
        >
          {isLoading ? 'Analyzing...' : 'Analyze Conversation'}
        </Button>
      </form>
    </div>
  );
}
